// extracted by mini-css-extract-plugin
var _1 = "actual__plzNL";
var _2 = "backgroundDecor__MlBqL";
var _3 = "bannerSection__gxHPI";
var _4 = "bullet__Z_Q33";
var _5 = "calculator__JZEnx";
var _6 = "container__gmC4D";
var _7 = "decorImage__jbWGX";
var _8 = "footnote__hdE_3";
var _9 = "leftSide__llXGR";
var _a = "rightSide__r8YXd";
var _b = "title__xeT4g";
export { _1 as "actual", _2 as "backgroundDecor", _3 as "bannerSection", _4 as "bullet", _5 as "calculator", _6 as "container", _7 as "decorImage", _8 as "footnote", _9 as "leftSide", _a as "rightSide", _b as "title" }
export default { "actual": _1, "backgroundDecor": _2, "bannerSection": _3, "bullet": _4, "calculator": _5, "container": _6, "decorImage": _7, "footnote": _8, "leftSide": _9, "rightSide": _a, "title": _b }
